import { SET_SENSORS } from '../constants/actionTypes';

export const setSensors = payload => {
  return {
    type: SET_SENSORS,
    payload
  };
};



// WEBPACK FOOTER //
// ./src/actions/sensors.js